/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Kezdőlap',
	homePageTabsLabel: 'Főoldal tartalom',
	myContent: 'Saját tartalom',
	teamContent: 'Csapattartalom',
	folder: 'Mappa',
	files: 'Fájlok',
	actionMenu: 'Műveleti menü',
	myFolder: 'Saját mappák',

	emptyFolderNoContent: 'Nincs tartalom',

	//EmptyStates
	emptyRecentTitle: 'Nem tekintett meg tartalmat a közelmúltban.',
	emptyStateTitle: 'Kezdje adatok hozzáadásával',
	emptyStateBody: 'Kattintson fenti Adatok feltöltése lehetőségre vagy húzzon át ide adatokat a feltöltéshez.',
	emptySearchResultTitle: 'Hmm, a keresés nem hozott eredményt.',
	emptyPortalTitle: 'Nincs portál',
	emptyPortalBody: 'Jelenleg nincsenek portáljai.',
	emptyWsProjectTitle: 'Kezdje egy munkafüzet létrehozásával a Watson Studio alkalmazásban.',
	emptyWsProjectBody: 'Amikor visszatér a Cognos Analytics alkalmazásba, a munkafüzet ott jelenik meg.',
	emptyFilteredResultTitle: 'Hmm, az alkalmazott szűrők nem adtak vissza eredményt.',
	emptyDialogViewTitle: 'Nincs elem',
	removeFromRecents: 'Eltávolítás a legutóbbiak közül',

	// Welcome Banner
	welcomeBannerGreeting: 'Helló! Üdvözli a Cognos Analytics with Watson!',
	welcomeBannerDescription: 'A Cognos Analytics with Watson az MI által vezérelt önkiszolgáló elemzést biztosítja a felhasználók részére. Tekintse meg, hogyan hozhat magabiztosabb döntéseket az automatikus adatfeldolgozás, adatfelderítés és megjelenítés segítségével.',
	welcomeBannerDescription_trialUser: 'Elkezdheti most azonnal azzal, hogy megtekinti a bemutató videónkat, termékismertetőnket és a Kezdeti lépések lapot.',
	takeTourButtonLabel: 'Termékbemutató megtekintése',
	watchVideoButtonLabel: 'Videó megtekintése',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Biztos benne, hogy kikapcsolja az üdvözlő fejléccsíkot a kezdőlapon? Ezt a Profil és beállítások > Beállítások > Általános oldalon bármikor visszakapcsolhatja. ',
	hideWelcomeBannerTitle: 'Üdvözlő fejléccsík kikapcsolása',
	ok: 'OK',
	cancel: 'Mégse',
	warn: 'Figyelmeztetés',
	//howto video dialog
	modal_how_title: 'Cognos Analytics bemutató megtekintése',
	modal_overview_title: 'Cognos Analytics bemutatásának megtekintése',
	modal_how_play: 'Videó lejátszása',
	modal_how_video_title_overview: 'Áttekintés',
	modal_how_video_title_getStarted: 'A V11.2 kezdeti lépései',
	modal_how_video_title_newUI: 'Üdvözli az új Cognos élmény',
	modal_how_video_title_dataModule: 'Adatmodulok bemutatása',
	modal_how_video_title_explore: 'Adatok böngészésének bemutatása',
	modal_how_video_title_dashboard: 'Interaktív műszerfalak bemutatása',
	modal_how_video_title_reporting: 'Jelentéskészítés bemutatása',
	modal_how_video_title_mobile: 'A Cognos ereje a tenyerében',

	// Toolbar
	search: 'Keresés',
	addFolder: 'Mappa hozzáadása',
	addLink: 'Hivatkozás hozzáadása',
	filter: 'Szűrő',
	sort: 'Rendezés',
	settings: 'Beállítások',
	tilesView: 'Mozaik nézet',
	listView: 'Listanézet',
	columnView: 'Oszlop nézet',
	backToSearch: 'Vissza a keresési találatokhoz',

	// Toolbar Actions
	sortBy: 'Rendezési szempont',
	sortOrder: 'Rendezés',
	name: 'Név',
	modifiedTime: 'Módosítva',
	type: 'Típus',
	ascending: 'Növekvő',
	descending: 'Csökkenő',
	resetSort: 'Rendezés alaphelyzetbe állítása',

	filterType: 'Típus',
	filterModificationTime: 'Módosítva',
	all: 'Mind',
	today: 'Ma',
	yesterday: 'Tegnap',
	pastWeek: 'Múlt hét',
	pastMonth: 'Előző hónap',
	resetFilters: 'Szűrők visszaállítása',
	resultLimit: 'Találati korlát',

	filterSearchPlaceHolder: 'Szűrés kulcsszavak szerint',

	resetFilterTag: 'Kattintson az X gombra a szűrők alaphelyzetbe állításához.',
	filterTagToolTip: 'Alkalmazott szűrők: %{appliedFilters}.',

	folderName: 'Mappanév',
	addAFolder: 'Mappa hozzáadása',
	add: 'Hozzáadás',
	error: 'Hiba',
	newFolderDefaultName: 'Új mappa',
	toastCreateNewFolder: 'A(z) %{nameOfFolder} mappa létrehozásra került a(z) %{tabName} mappában.',
	folderAdded: 'Mappa hozzáadva',
	refresh: 'Frissítés',
	openFolder: 'Mappa megnyitása',

	addAUrl: 'URL hozzáadása',
	linkName: 'URL neve',
	linkNamePlaceholder: 'URL név hozzáadása',
	linkDescription: 'Leírás (nem kötelező)',
	linkDescriptionPlaceholder: 'Leírás hozzáadása',
	linkUri: 'URL cím',
	linkUriPlaceholder: 'Adjon hozzá olyan URL címet egy elfogadható tartománnyal',
	acceptableDomains: 'Elfogadható tartományok',
	viewAcceptableDomains: 'Elfogadható tartományok megtekintése',
	mandatoryField: 'Kötelező mező',
	linkAdded: 'URL hozzáadva',
	toastCreateNewLink: 'A(z) %{nameOfLink} hozzáadásra került a következőhöz: %{tabName}.',
	noEntries: 'Az elfogadható tartományok listája nem tartalmaz bejegyzéseket. Forduljon az adminisztrátorhoz.',
	unacceptableDomain: 'Az URL érvénytelen tartományt használ. Kattintson az \'Elfogadható tartományok megtekintése\' funkcióra a használható tartományok listájának megjelenítéséhez.',

	compact: 'Tömör',
	short: 'Rövid',
	default: 'Alapértelmezett',
	rowSize: 'Sor mérete',

	// GroupyByTypes
	folders: 'Mappák',
	reports: 'Jelentések',
	dashboards: 'Műszerfalak',
	data: 'Adatok',
	packages: 'Csomagok',
	explorations: 'Böngészések',
	stories: 'Történetek',
	notebooks: 'Notebook dokumentumok',
	others: 'Egyéb',

	// Error Messages
	itemsOverLimit: 'A megadott "%{itemName}" név meghaladja a maximális korlátot (20). A folytatáshoz adjon meg másik nevet.',
	errorMessageLengthFolderName: 'Adjon meg olyan mappanevet, amely nem haladja meg a 255 karaktert.',
	errorMessageLengthLinkName: 'Adjon meg olyan hivatkozásnevet, amely nem haladja meg a 255 karaktert.',
	toastLaunchPerspectiveError: 'A(z) %{objectType} nem nyitható meg.',
	errorNoAccessTitle: 'Hmm, úgy tűnik, nem rendelkezik hozzáféréssel ehhez a tartalomhoz',
	errorNoAccessBody: 'Forduljon az adminisztrátorhoz, vagy tekintse meg a következő hivatkozást:',
	errorEnableExternalContent: 'Külső tartalom engedélyezése',

	//TableHeader
	lastAccessed: 'Legutóbbi hozzáférés',
	location: 'Hely',
	tenant: 'Bérlő',

	// GetStartedTab
	getStartedLabel: 'Az IBM Cognos Analytics használatának megkezdése',
	learningHowToLabel: 'Tanulási információforrások',
	learningHowToDescription: 'A csatlakozással a közösséghez, a dokumentáció olvasásával és a videók megtekintésével bővítheti a tudását és segítséget is kaphat.',
	learningHowToActionLabel: 'Tanulás panel indítása',
	howToVideosLabel: 'Tanácsadó videók',
	howToVideosDescription: 'Megismerkedhet az IBM Cognos Analytics használatával és betekintést nyerhet az adataiba.',
	howToVideosActionLabel: 'Videók megtekintése',
	acceleratorCatalogLabel: 'Gyorsító katalógus',
	acceleratorCatalogDescription: 'Böngéssze az iparági használat, követendő eljárásokat tartalmazó útmutatók, egyéni ábrázolások, stb. növekvő katalógusát.',
	acceleratorCatalogActionLabel: 'Katalógus böngészése',
	sampleSectionTitle: 'Minták',
	sampleSectionDescription: 'Kísérletezzen a példákkal, amelyek bemutatják, hogy a Cognos Analytics mi mindent tud nyújtani.',
	// Samples Section
	createDashboardSampleTitle: 'Az első műszerfal létrehozása',
	createDashboardSampleDescription: 'Kezdje meg elemzési útját a Cognos Dashboards alkalmazással.',
	nlaSampleTitle: 'Minta jelentés',
	nlaSampleDescription: 'A példán keresztül megismerheti, hogy mire képes a Cognos Analytics Reports az év végi hűségkártya tagtevékenység elemzésével.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Bővítse megjelenítési könyvtárát egyéni megjelenítésekkel, mint például a Sankey diagram.',
	viewAllSamplesActionLabel: 'Összes minta megtekintése',
	byFeatureTitle: 'Szolgáltatás szerint',
	byFeatureDescription: 'Minták tallózása szolgáltatás alapján, például alapműködés, egyéni vezérlők, bővítmények, munkafüzetek és relatív dátumok. ',
	byIndustryTitle: 'Iparág szerint',
	byIndustryDescription: 'Minták tallózása iparág alapján, például, autóipar, bankszektor, stb. ',
	// SamplesTab
	sampleTabTitle: 'Merítsen ötleteket a beépített mintákból',
	sampleTabLabel: 'Keresse fel az Accelerator katalógust további mintákért és bővítményeként az IBM, partnerei és vevői részéről. ',

	// quickLaunch
	quickLaunchLabel: 'Gyors indítás',
	expand: 'Kibontás',
	collapse: 'Visszazárás',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Kezdje azzal, hogy kiválasztja, mit szeretne létrehozni.',

	// contentPageView
	contentPageTitleLabel: 'Tartalom',
	uploadFile: 'Adatok feltöltése',
	new: 'Új',
	create: 'Létrehozás',
	more: 'Továbbiak',

	// open dialog
	selectDataSourcesToAdd: 'Válassza ki a hozzáadandó adatforrás(oka)t.',
	openDialogDefaultTitle: 'Megnyitás',

	// save dialog
	save: 'Mentés',
	saveAs: 'Mentés másként',
	saving: 'Mentés...',
	selectedDestination: 'Kiválasztott cél: %{nameOfFolder}',
	toastDuplicateFileDifferentType: 'A(z) \'%{nameOfItem}\' eltérő típussal már létezik. Válasszon másik nevet.',
	confirmOverwriteTitle: 'A meglévő adatok cseréjének megerősítése',
	confirmOverwriteMsg: 'A(z) \'%{nameOfFile}\' fájl már létezik. Lecseréli az adatait a kijelölt fájlban található adatokra?',

	// copy move dialog
	copy: 'Másolás',
	move: 'Áthelyezés',
	copyOrMove: 'Másolás vagy áthelyezés: ',
	copyOnly: 'Másolás ',
	createShortcut: 'Parancsikon létrehozása',
	createShortcutDialogTitle: 'Parancsikon létrehozása: ',

	// External asset types
	wsProject: 'Watson Studio projekt',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Csomag',
	dataModule: 'Adatmodul',
	exploration: 'Böngészés',
	mode: 'Mód',
	live: 'Élő',
	snapshot: 'Pillanatkép',
	noSnapshotsFound: 'Nem található pillanatkép',
	uploadedFile: 'Feltöltött fájl',
	fileUpload: 'Adatok feltöltése',
	dataSetEx: 'Adathalmaz',
	externalRepository: 'Külső tár',
	queryMode: 'Lekérdezési mód',
	queryModeCompatible: 'Kompatibilis',
	queryModeDynamic: 'Dinamikus',
	report: 'Jelentés',
	activeReport: 'Aktív jelentés',
	query: 'Lekérdezés',
	analysis: 'Elemzés',
	dashboard: 'Műszerfal',
	dashboardTemplate: 'Műszerfal sablon',
	jupyterNotebook: 'Munkafüzet',
	wsNotebook: 'Watson Studio notebook',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Történet',
	workspace: 'Munkaterület',
	pagelet: 'Lap',
	content: 'Tartalom',
	directory: 'Névterek',
	dataSet: 'Adathalmaz',
	powerPlayCube: 'PowerPlay kocka',
	powerPlayReport: 'PowerPlay jelentés',
	powerPlay8Report: 'PowerPlay jelentés',
	setPowerPlay8ReportOptions: 'PowerPlay jelentésbeállítások megadása',
	powerPlay8ReportView: 'PowerPlay jelentés nézet',
	reportTemplate: 'Jelentéssablon',
	packageConfigurations: 'Csomagkonfiguráció',
	agent: 'Ügynök',
	agentDefinition: 'Ügynökdefiníció',
	agentDefinitionView: 'Ügynöknézet',
	dataMovementTask: 'Adatáthelyezési feladat',
	dataMovementTaskAlias: 'Adatáthelyezési feladat álneve',
	document: 'Dokumentum',
	DocumentRetention: 'Dokumentumtulajdonságok',
	jobDefinition: 'Munkameghatározás',
	job: 'Munka',
	jobs: 'Feladatok',
	metricsDataSourceETLTask: 'Metrika-adatforrás ETL-feladata',
	metricsExportTask: 'Metrikaexportálási feladat',
	metricsFileImportTask: 'Metrikafájl-importálási feladat',
	metricsMaintenanceTask: 'Metrika-karbantartási feladat',
	planningTask: 'Tervezési feladat',
	shortcut: 'Parancsikon',
	shortcuts: 'Gyorsbillentyűk',
	URL: 'URL-cím',
	launchable: 'Indítható',
	dataSetFolder: 'Adatkészletmappa',
	ViewAccessibleLabel: '%{label} megtekintése',
	overrideReportOptions: 'Alapértelmezett jelentésbeállítások felülbírálása',
	formats: 'Formátumok',
	saveReport: 'Jelentés mentése',
	reportView: 'Jelentésnézet',
	reportviews: 'Jelentés nézetek',
	html: 'HTML',
	pdf: 'PDF',
	spreadsheetML: 'Excel',
	xlsxData: 'Excel-adatok',
	csv: 'CSV',
	xml: 'XML',
	txt: 'TXT',
	role: 'Szerep',
	namespace: 'Névtér',
	namespaceFolder: 'Névtér mappája',
	adminFolder: 'Adminisztrátori mappa',
	//Details
	details: 'Részletek',
	open: 'Megnyitás',
	created: 'Létrehozva',
	modified: 'Módosítva',
	owner: 'Tulajdonos',
	dataSource: 'Adatforrás',
	share: 'Megosztás',
	addToFavorites: 'Hozzáadás a kedvencekhez',
	properties: 'Tulajdonságok',
	detailsEmptyStateBody: 'Elem kiválasztása a részletek megtekintéséhez',
	editNameAndDescription: 'Név és leírás szerkesztése',
	none: 'Nincs',
	setPdfOptions: 'PDF-beállítások megadása',
	runOptions: 'Futtatási beállítások',

	//rename dialog
	nameInvalid: 'A név érvénytelen',
	namePlaceholder: 'Név megadása',
	description: 'Leírás',
	descriptionInvalid: 'A leírás nem haladhatja meg a 350 karaktert. ',
	descriptionPlaceholder: 'Adjon meg egy leírást',
	errorMessageApostropheError: 'Olyan fájlnevet adjon meg, amely nem tartalmaz \'  és " karaktereket',
	renameCollisionError: 'A(z) %{name} már létezik. Adjon meg másik nevet.',
	unknownRenameError: 'Az elem átnevezése sikertelen volt. További segítségért forduljon az adminisztrátorhoz.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'A megadott mappa nem nyitható meg.',

	//Upload
	uploadToFolder: "Feltöltés ide: <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Feltöltés a(z) <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> mappába és a(z) {launchAction} indítása",
	quickUpload: "Gyors feltöltés",
	quickUploadAndLaunch: "Húzzon át ide fájlokat a feltöltéshez a(z) <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> helyre és a megnyitáshoz a következő területek egyikében.",
	unsupportedFilesSingle: "A(z) %{files} feltöltése meghiúsult, mert Gyors indítás esetén érvénytelen.",
	unsupportedFilesMultiple: "A fájlok nem lettek feltöltve, mert a Gyors indítás használatához az összes kiválasztott fájlnak érvényesnek kell lennie.",
	unsupportedFilesSingleInvalid: "A(z) %{files} érvénytelen.",
	unsupportedFilesMultipleInvalid: "A(z) %{files} érvénytelen.",
	supportedFileTypes: "Csak a következő fájltípusok engedélyezettek: %{extensions}.",
	uploadDragAndDrop: "Áthúzás",
	uploadDragAndDropMessage: "Húzza át a fájlokat ide a feltöltésükhöz a(z) <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> helyre",

	// searchBar
	searchWasSaved: 'A(z) \'%{searchTerm}\' keresési feltétel mentésre került.',
	searchWasntSaved: 'A(z) \'%{searchTerm}\' keresési feltétel nem került mentésre.',
	searchSuggestions: 'Javaslatok',
	savedSearch: 'Mentett keresések',
	searchWasDeleted: 'A(z) \'%{searchTerm}\' keresési feltétel törlésre került.',
	searchWasntDeleted: 'A(z) \'%{searchTerm}\' keresési feltétel nem került törlésre.',
	savedBarTitle: 'Keresés a Cognos Analytics alkalmazásban',
	searchContentPageTitle: 'Keresés',
	searchContentPageTitleLabel: '\'%{searchTerm}\' eredményeinek megjelenítése',
	showingSearchRsult: '%{resultCount} elem megjelenítése',
	saveSearch: 'Keresés mentése',
	saveTenSearches: '10 keresést menthet.',
	deleteASearch: 'Újabb mentéséhez töröljön egy korábbit.',
	close: 'Bezárás',
	allContent: 'Teljes tartalom',
	searchResultIn: 'Keresési eredmények a következőben: ',
	//recent view
	recents: 'Legutóbbi',
	noAccessRecent: 'Nincs hozzáférés',
	noAccessRecentMsg: 'Nem rendelkezik hozzáféréssel ehhez az eszközhöz. Lehet hogy tiltott vagy törölték, vagy csökkentették az engedélyeit. Ellenőrizze az eszköz állapotát a feltételezett forráshelyén. Az OK gombra kattintva eltávolíthatja az elemet az újkeletű elemek közül.',
	noAccessMsg: 'Nem rendelkezik hozzáféréssel ehhez az eszközhöz. Lehet hogy tiltott vagy törölték, vagy csökkentették az engedélyeit.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} elem kiválasztva',
	itemSelected: '%{nameOfSelection} elem kiválasztva',

	//properties
	general: 'Általános',
	schedule: 'Ütemezés',
	permission: 'Engedélyek',
	capabilities: 'Képességek',
	propertiesTabsLabel: 'Tulajdonságok tartalma',
	searchPath: 'Keresési útvonal',
	id: 'Azonosító',
	language: 'Nyelv',
	setLanguage: 'Nyelv beállítása',
	entryOptions: 'Beviteli beállítások',
	setPackage: 'Csomag vagy modul beállítása',
	sourcePackage: 'Forráscsomag vagy adatmodul',
	associatedSourceAgent: 'Forráscsomag',
	setAssociatedSourceAgent: 'Csomag beállítása',
	sourceAgent: 'Forrásügynök',
	setSourceAgent: 'Forrásügynök beállítása',
	setCapabilities: 'Képességek beállítása',
	disableEntry: 'Adott bejegyzés letiltása',
	hideEntry: 'Adott bejegyzés elrejtése',
	permissions: 'Engedélyek',
	promptForValues: 'Értékek bekérése',
	yes: 'Igen',
	no: 'Nem',
	setValues: 'Értékek beállítása',
	moreOptions: 'További beállítások',
	reportFormat: 'Jelentés formátuma',
	enableAccessibilitySupport: 'Kisegítő lehetőségek támogatásának engedélyezése',
	displayOfRunHistory: 'Futási előzmények megjelenítése',
	occurrences: 'Előfordulások',
	days: 'Nap(ok)',
	months: 'Hónap(ok)',
	displayOfReportOutputVersions: 'A jelentéskivitel verziójának megjelenítése',
	defaultDisplayOfPortalAction: 'Alapértelmezett portálművelet',
	viewMostRecentReport: 'Legutóbbi jelentés megtekintése',
	runTheReport: 'Jelentés futtatása',
	openWithReportStudio: 'Megnyitás a Report Studio alkalmazással',
	rowsPerPageInHtmlReports: 'Sorok száma oldalanként a HTML jelentésekben',
	enableSelectionBasedInteractivity: 'Kiválasztásalapú interaktivitás engedélyezése',
	enableAlertsAboutNewVersions: 'Riasztás engedélyezése új változatok esetén',
	enableEnhancedUserFeaturesInSavedOutputVersions: 'Bővített felhasználói szolgáltatások engedélyezése a mentett kimenet változatokban',
	enableCommentsInSavedOutputVersions: 'Megjegyzések engedélyezése a mentett kimenet változatokban',
	run: 'Futtatás',
	runWithUsersCredentials: 'A felhasználó hitelesítési adataival',
	runWithOwnerCapabilities: 'Tulajdonosi képességgel',
	runAsOwner: 'Mint %{ownerName}',
	actionLabelOn: 'Be',
	actionLabelOff: 'Ki',
	openReport: 'Szerkesztés',
	openAnalysis: 'Megnyitás az Analysis Studio alkalmazással',
	openQuery: 'Megnyitás a Query Studio alkalmazással',
	openPowerPlay8Report: 'Megnyitás a PowerPlay Studio alkalmazással',
	openInteractiveReport: 'Szerkesztés',
	read: 'Olvasás',
	write: 'Írás',
	execute: 'Végrehajtás',
	setPolicy: 'Irányelv beállítása',
	full: 'Teljes',
	traverse: 'Bejárás',
	grant: 'Megadás',
	deny: 'Elutasítás',
	permissionCustom: 'Egyéni',
	permissionDetailsColumnAccess: 'Hozzáférés',
	permissionDetailsColumnPermission: 'Engedély',
	permissionDetailsColumnAction: 'Művelet',
	permissionSetAccess: 'Hozzáférés beállítása',
	permissionRead: 'Olvasás',
	permissionRun: 'Futtatás',
	permissionWrite: 'Írás',
	permissionFull: 'Teljes',
	unavailable: 'Nem elérhető',
	unkownSource: 'Ismeretlen, jelentés megnyitása a részletekért.',
	tenantSettings: 'Bérlő beállításai',
	tenantSet: 'Bérlő frissítve',
	tenantSetError: 'Hiba a bérlő beállítása közben',
	tenantClear: 'Bérlő törölve',
	tenantClearError: 'Hiba a bérlő törlése közben',
	shortcutTo: 'Parancsikon a következőhöz:',
	sourceReport: 'Forrásjelentés',
	setSourceReport: 'Forrásjelentés beállítása',
	setSourceLocation: 'Forrás %{itemName} helyének beállítása',
	linkPackageOrModule: 'A(z) %{itemName} hozzákapcsolása egy csomaghoz vagy adatmodulhoz',
	linkPackage: 'A(z) %{itemName} hozzákapcsolása egy csomaghoz',
	externalRepositories: 'Külső tárak',
	sizeByte: '%{value} B',
	sizeKiloByte: '%{value} KB',
	sizeMegaByte: '%{value} MB',
	sizeGigaByte: '%{value} GB',
	sizeTeraByte: '%{value} TB',
	sizePetaByte: '%{value} PB',
	refreshedDatetime: 'Frissítés időpontja',
	size: 'Méret',
	tenantsWarningMessage: 'A bejegyzés bérlőjének módosításával megváltozik a gyerekbejegyzések bérlője is.',
	confirmClearTenantText: 'A \'Nincs\' érték törlésével lehetővé teheti más bérlők számára is a tartalom elérését. A bejegyzés nyilvánossá tételéhez kattintson az OK gombra, a jelenlegi bérlő megtartásához pedig a Mégse gombra.',
	confirmClearTenant: 'A bérlő törlésének megerősítése',
	currentValues: 'Aktuális értékek',
	emptyPromptValues: 'Jelenleg nincsenek értékek',
	editValues: 'Értékek szerkesztése',
	clear: 'Kiürítés',
	source: 'Forrás',
	dataRefreshed: 'Adatok frissítve',
	//PDF options
	pdfOptions: 'PDF beállítások',
	set: 'Halmaz',
	portrait: 'Álló',
	landscape: 'Fekvő',
	letter: 'Levél',
	legal: 'Jogi',
	elevenxSeven: '11x17',
	A3: 'A3',
	A4: 'A4',
	b4jis: 'B4JIS',
	b5jis: 'B5JIS',
	orientation: 'Tájolás',
	pageDefination: 'Papírméret',
	openPasswordRequired: 'Legyen szükséges jelszó a jelentés megnyitásához',
	accessPasswordRequired: 'Jelszó megkövetelése a jelentés elérésekor',
	emptyPassword: 'A jelszó nem lehet üres',
	password: 'Jelszó',
	enterPassword: 'Adja meg a jelszót',
	confirmPassword: 'Jelszó megerősítése',
	passwordMatchError: 'A jelszavak nem egyeznek',
	gateway: 'Átjáró',
	pageLayout: 'Oldalelrendezés',
	pageStyle: 'Stílus',
	setUrl: 'URL beállítása',
	numberRows: 'Sorok száma',
	numberColumns: 'Oszlopok száma',
	timeToRefresh: 'Frissítés időpontja',
	lastRefreshedBy: 'Frissítette:',
	unknown: 'Ismeretlen',
	unknownUpdateError: 'Az elem frissítése nem sikerült. További segítségért forduljon az adminisztrátorhoz.',
	editQuery: 'Lekérdezés szerkesztése',
	greaterOrEqual: 'Nagyobb vagy egyenlő, mint %{upperboundValue}',
	lessOrEqual: 'Kisebb vagy egyenlő, mint %{lowerboundValue}'
});
